import React, { useEffect, useState } from 'react';
import { InputAdornment, ListItemButton } from '@mui/material';
import {
  Box,
  Button,
  Checkbox,
  IconButton,
  List,
  ListItemIcon,
  ListItemText,
  Paper,
  TextField,
} from '@mui/material';
import Grid from '@mui/material/Grid2';
import {
  Check,
  Close,
  Save,
  SaveAlt,
  SaveAs,
  SaveOutlined,
} from '@mui/icons-material';

import { changeUserRequest } from '../api';

import { useGetOrders } from 'src/services/apiService';
import { EntityTitle } from 'src/components/EntityTitle';
import { Contractors } from 'src/components/Contractors';
import { Orders } from 'src/components/orders';

//entities
import { deleteUserFromContractor } from 'src/entities/contractor';

//shared
import { WithConfirm } from 'src/shared/ui';
import { Contractor, User as IUser, UserRole } from 'src/shared/api';
import { NotificationsList } from 'src/entities/notification';
import { Link } from 'react-router-dom';

interface Props {
  user?: IUser;
  onChanage?: () => any;
}

export const User: React.FunctionComponent<Props> = ({ user, onChanage }) => {
  const [state, setState] = useState({
    vendorId: user?.vendorId || '',
  });

  const ordersRequest = useGetOrders({
    variables: { users: user?.id as number, limit: 10 },
    skip: !user,
  });

  useEffect(() => {
    setState({
      vendorId: user?.vendorId || '',
    });
  }, [user]);

  const handleLogin = () =>
    fetch(`${process.env.REACT_APP_API_HOST}/v1_api/users/me`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'X-Switch-User': `${user?.phoneNumber}`,
      },
      redirect: 'manual',
      credentials: 'include',
    }).then(() => {
      //@ts-ignore
      window.location.href = 'https://instock-dv.ru/';
    });

  const handleSave = (data: Partial<IUser>) =>
    changeUserRequest(user?.id as number, data).then(onChanage);

  const handleDeleteContractor = (contractor: Contractor) => {
    if (contractor?.id && user?.id) {
      deleteUserFromContractor(contractor.id, user?.id).then(onChanage);
    }
  };

  const contractorActions = (contractor: Contractor) => (
    <WithConfirm
      onConfirm={() => handleDeleteContractor(contractor)}
      confirmTitle="Удалить"
    >
      <IconButton size="small" color="error" title="Удалить пользователя">
        <Close />
      </IconButton>
    </WithConfirm>
  );

  return (
    <div>
      {user && (
        <>
          <EntityTitle
            id={user?.id}
            title={[user?.lastName, user?.firstName, user?.fatherName]
              .filter(item => item)
              .join(' ')}
          />
          <Paper>
            <Box p={2}>
              <Grid container spacing={2}>
                <Grid size={{ xs: 12, sm: 3 }}>
                  <TextField
                    fullWidth
                    value={user.phoneNumber}
                    label="Телефон"
                    variant="outlined"
                    disabled
                  />
                  <Box display="flex" mt={2}>
                    <TextField
                      fullWidth
                      value={state.vendorId}
                      label="Код торгового агента"
                      onChange={e =>
                        setState({ ...state, vendorId: e.target.value })
                      }
                      variant="outlined"
                      InputProps={{
                        endAdornment: state.vendorId !== user.vendorId && (
                            <InputAdornment position="end">
                              <IconButton
                                onClick={() =>
                                  handleSave({ vendorId: state.vendorId })
                                }
                              >
                                <SaveOutlined />
                              </IconButton>
                            </InputAdornment>
                          ),
                      }}
                    />
                  </Box>
                                    <Box display="flex" mt={2}>
                    <TextField
                      fullWidth
                      value={user.vendorData}
                      label="Название агента"
                      disabled
                      variant="outlined"

                    />
                  </Box>
                </Grid>
                <Grid size={{ xs: 12, sm: 3 }}>
                  <List disablePadding>
                    {Object.values(UserRole).map(role => (
                      <ListItemButton
                        onClick={() =>
                          handleSave({
                            roles: user?.roles?.includes(role)
                              ? user?.roles?.filter(item => item !== role)
                              : [...(user?.roles || []), role],
                          })
                        }
                      >
                        <ListItemIcon>
                          <Checkbox checked={user?.roles?.includes(role)} />
                        </ListItemIcon>
                        <ListItemText primary={role} />
                      </ListItemButton>
                    ))}
                  </List>
                </Grid>
                <Grid size={{ xs: 12, sm: 3 }}>
                  <List disablePadding>
                    <ListItemButton
                      onClick={() =>
                        handleSave({
                          disabled: !user?.disabled,
                        })
                      }
                    >
                      <ListItemIcon>
                        <Checkbox checked={user?.disabled} />
                      </ListItemIcon>
                      <ListItemText primary="Заблокирован" />
                    </ListItemButton>
                  </List>
                </Grid>
                <Grid size={{ xs: 12, sm: 3 }}>
                  <Button
                    onClick={handleLogin}
                    variant="contained"
                    color="primary"
                    fullWidth
                  >
                    Войти как пользователь
                  </Button>
                </Grid>
              </Grid>
            </Box>
          </Paper>
          <Box mt={2}>
            <Paper>
              <Contractors
                contractors={user?.contractors}
                limit={user?.contractors?.length}
                offset={0}
                onFetch={() => null}
                onChange={() => null}
                loading={false}
                contractorActions={contractorActions}
              />
            </Paper>
          </Box>
        </>
      )}
      <Box mt={2}>
        {ordersRequest.data?.data && (
          <Orders
            data={ordersRequest.data?.data}
            loading={ordersRequest.isLoading}
          />
        )}
      </Box>
      <Box mt={2}>
        <NotificationsList userId={user?.id} />
      </Box>
    </div>
  );
};
